import React, { useState } from "react";
import Modal from "react-modal";
import Styles from "./cancel.module.css";
import ReactLoading from "react-loading";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
function Add({ completemodal, setModal, data, cancelClass }) {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const token = { Authorization: `token ${localStorage.getItem("token")}` };
    const [options, setOptions] = useState([]);
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        setError,
        clearErrors,
        unregister,
        setValue,
        watch,
    } = useForm({ Requested_By: "", CancelType: "", Comments: "" });

    const inputData = watch();

    const types = [
        {
            type: "Parent_Requested",
            reason: "Parent requested the cancellation",
        },
        { type: "Public_Holiday", reason: "Public holiday" },
        { type: "Student_No_Show", reason: "Student no show" },
        { type: "Tutor_No_Show", reason: "Teacher no show" },
        { type: "Half_Attended", reason: "Less than 50% of Attendance" },
    ];

    async function onSubmit(formData) {
        //CancelReason
        //CancelType
        console.log(formData);
        if (formData?.Requested_By == 3) {
            navigate("/tutor-cancel/Tutor_required");
            return;
        }
        let body = { ...formData };
        if (
            data.BatchSize != "One-to-One" &&
            formData.CancelType == "Student_No_Show" &&
            formData?.CancelType != "Parent_Requested"
        ) {
            setError("CancelType", {
                message: "Student no show is not applicable for Group class",
            });
            return;
        }
        if (
            data.BatchSize == "One-to-One" &&
            formData.CancelType == "Half_Attended" &&
            formData?.CancelType != "Parent_Requested"
        ) {
            setError("CancelType", {
                message:
                    "Less than 50% Attendance is not applicable for One-on-One class",
            });
            return;
        }
        if (
            data.BatchSize != "One-to-One" &&
            formData.CancelType == "Parent_Requested"
        ) {
            setError("Cancellation_Policy_Type", {
                message: "This is not applicable for Group class",
            });
            return;
        }

        if (formData.Requested_By == "4") {
            body = {
                ...body,
                Cancellation_Policy_Type: formData?.Cancellation_Policy_Type,
                IsPenalityCharged:
                    formData?.Cancellation_Policy_Type == "Is_After" ? 1 : 0,
            };
        } else {
            let reason = options.find(
                (item) => item.type == formData.CancelType
            );
            body = {
                ...body,
                CancelType: formData.CancelType,
                CancelReason: reason.reason,
            };
            /*    if (formData?.CancelType == "Others") {
                body = {
                    ...body,
                    CancelType: "Others",
                    CancelReason: formData?.Comments,
                };
            } */
        }
        setLoading(true);
        await cancelClass(body);
        setLoading(false);
    }
    const requestHandler = (e) => {
        let value = e.target.value;
        /* if (value == "4" || value == "3") {
            unregister("CancelType");
        }
        if (value == 3) {
            unregister("Requested_By");
        }
        if (inputData?.CancelType != "Parent_Requested" || value == 3) {
            unregister("Cancellation_Policy_Type");
        } */
        if (value == 4) {
            setOptions([
                {
                    type: "Parent_Requested",
                    reason: "Parent requested the cancellation",
                },
            ]);
            setValue("CancelType", "Parent_Requested");
            setValue("CancelReason", "Parent requested the cancellation");
        } else {
            setValue("CancelType", "");
            setValue("CancelReason", "");
            unregister("Cancellation_Policy_Type");
            if (value == 1) {
                setOptions([
                    { type: "Public_Holiday", reason: "Public holiday" },
                    {
                        type: "Student_No_Show",
                        reason: "Student no show for 1:1",
                    },
                    { type: "Tutor_No_Show", reason: "Teacher no show" },
                    {
                        type: "Half_Attended",
                        reason: " Student no show for group",
                    },
                    { type: "Others", reason: "Others" },
                ]);
            } else if (value == 3) {
                setOptions([
                    {
                        type: "Bereavement",
                        reason: "Bereavement",
                    },
                    { type: "One_Day", reason: "One Day" },
                    {
                        type: "6_Class_Cancellation",
                        reason: "6 Class Cancellation",
                    },
                    { type: "Medical_Emergency", reason: "Medical Emergency" },
                    { type: "Others", reason: "Others" },
                ]);
            }
        }
    };
    return (
        <div>
            <Modal
                isOpen={completemodal}
                contentLabel="Modal"
                onRequestClose={() => {
                    setModal(false);
                    reset({ Requested_By: "", CancelType: "", Comments: "" });
                    clearErrors();
                }}
                className={Styles["modal"]}
                overlayClassName={Styles["overlay"]}>
                <div className={Styles["wrapper"]}>
                    <header>
                        <h3>Cancel Class</h3>
                    </header>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className={Styles["form-control"]}>
                            <label htmlFor="Reason">Requested By</label>
                            <select
                                defaultValue={""}
                                {...register("Requested_By", {
                                    required: "This is required",
                                    onChange: (e) => requestHandler(e),
                                })}>
                                <option value={""} disabled>
                                    Requested By
                                </option>
                                <option value="4">Parent</option>
                                {/* {<option value="3">Tutor</option> */}
                                <option value="1">Admin</option>
                            </select>
                            {errors.Requested_By && (
                                <span style={{ color: "red" }}>
                                    {errors.Requested_By.message}
                                </span>
                            )}
                        </div>
                        {inputData?.Requested_By != 4 &&
                            inputData?.Requested_By != 3 && (
                                <div className={Styles["form-control"]}>
                                    <label htmlFor="Reason">
                                        Cancellation Reason
                                    </label>
                                    <select
                                        defaultValue={""}
                                        {...register("CancelType", {
                                            required: "This is required",
                                        })}>
                                        <option value={""} disabled>
                                            Select Reason
                                        </option>
                                        {options.map((item) => (
                                            <option value={item.type}>
                                                {item.reason}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.CancelType && (
                                        <span style={{ color: "red" }}>
                                            {errors.CancelType.message}
                                        </span>
                                    )}
                                </div>
                            )}

                        {inputData?.CancelType == "Parent_Requested" &&
                            inputData?.Requested_By != 3 && (
                                <div className={Styles["form-control"]}>
                                    <label htmlFor="Reason">
                                        Request Type{" "}
                                    </label>
                                    <select
                                        defaultValue={""}
                                        {...register(
                                            "Cancellation_Policy_Type",
                                            {
                                                required: "This is required",
                                            }
                                        )}>
                                        <option value={""} disabled>
                                            Select Type
                                        </option>

                                        <option value="Is_After">
                                            Parent asked to cancel within 60
                                            minutes{" "}
                                        </option>
                                        <option value="Is_Before">
                                            Parent asked to cancel before 60
                                            minutes
                                        </option>
                                    </select>
                                    {errors.Cancellation_Policy_Type && (
                                        <span style={{ color: "red" }}>
                                            {
                                                errors?.Cancellation_Policy_Type
                                                    ?.message
                                            }
                                        </span>
                                    )}
                                </div>
                            )}
                        {inputData?.Requested_By != 3 && (
                            <div className={Styles["form-control"]}>
                                <label htmlFor=""> Comments</label>
                                <textarea
                                    {...register("Comments", {
                                        required: "This field is required",
                                    })}></textarea>
                                {errors.Comments && (
                                    <span style={{ color: "red" }}>
                                        {errors.Comments.message}
                                    </span>
                                )}
                            </div>
                        )}
                        {loading ? (
                            <div
                                style={{
                                    justifySelf: "center",
                                    marginTop: "1rem",
                                }}>
                                {" "}
                                <ReactLoading
                                    color="green"
                                    type="spokes"
                                    height={30}
                                    width={30}
                                />
                            </div>
                        ) : (
                            <div className={Styles["Control-btns"]}>
                                <button type="submit">Cancel Class</button>
                                <button
                                    type="button"
                                    onClick={() => {
                                        setModal(false);
                                        clearErrors();
                                        reset({
                                            Requested_By: "",
                                            CancelType: "",
                                            Comments: "",
                                        });
                                    }}>
                                    close
                                </button>
                            </div>
                        )}
                    </form>
                </div>
            </Modal>
        </div>
    );
}

export default Add;
